var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileTransferDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1069 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1199_51228)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_1199_51228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.998 146.994C227.012 134.771 218.375 123.066 209.839 118.027C206.268 115.919 201.895 114.724 196.585 114.978C196.428 112.928 195.275 100.4 185.164 92.1005C177.288 85.6361 168.812 85.7039 166.035 85.868C152.821 86.6486 145.079 96.9149 143.852 98.5984C142.942 98.2409 131.356 93.9299 121.436 101.894C113.893 107.95 110.403 118.622 112.625 128.944C111.371 128.969 105.167 129.235 100.377 134.664C99.5241 135.631 94.3539 141.706 95.8706 149.946C97.0127 156.152 101.506 161.187 107.41 162.985H209.795C211.274 162.344 221.338 157.781 223.998 146.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.998 146.994C227.012 134.771 218.375 123.066 209.839 118.027C206.268 115.919 201.895 114.724 196.585 114.978C196.428 112.928 195.275 100.4 185.164 92.1005C177.288 85.6361 168.812 85.7039 166.035 85.868C152.821 86.6486 145.079 96.9149 143.852 98.5984C142.942 98.2409 131.356 93.9299 121.436 101.894C113.893 107.95 110.403 118.622 112.625 128.944C111.371 128.969 105.167 129.235 100.377 134.664C99.5241 135.631 94.3539 141.706 95.8706 149.946C97.0127 156.152 101.506 161.187 107.41 162.985H209.795C211.274 162.344 221.338 157.781 223.998 146.994Z",
    fill: "url(#paint0_linear_1199_51228)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.609 115.477L196.123 115.501L196.086 115.016C195.931 112.986 194.787 100.647 184.846 92.487C177.114 86.1401 168.791 86.206 166.065 86.3671C153.095 87.1333 145.473 97.2229 144.256 98.8929L144.029 99.205L143.669 99.0638C142.776 98.7132 131.438 94.5053 121.749 102.284C114.369 108.209 110.927 118.682 113.114 128.838L113.242 129.431L112.635 129.444C111.422 129.468 105.399 129.727 100.752 134.995L100.752 134.995C99.9128 135.946 94.8908 141.861 96.3623 149.856L96.3623 149.856C97.4665 155.855 101.797 160.724 107.485 162.485H209.691C211.442 161.715 220.965 157.207 223.512 146.874L223.998 146.994L223.512 146.874C224.982 140.914 223.617 135.063 220.813 130.061C218.008 125.056 213.778 120.933 209.585 118.458C206.101 116.402 201.826 115.228 196.609 115.477Z",
    stroke: "#E1E9FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1199_51228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.368 123.375H168.253V118.917C168.253 113.999 164.254 110 159.336 110C154.419 110 150.419 113.999 150.419 118.917V123.375H149.305C147.462 123.375 145.961 124.875 145.961 126.719V142.324C145.961 144.168 147.462 145.668 149.305 145.668H169.368C171.211 145.668 172.712 144.168 172.712 142.324V126.719C172.712 124.875 171.211 123.375 169.368 123.375ZM153.392 118.917C153.392 115.639 156.058 112.972 159.336 112.972C162.615 112.972 165.281 115.639 165.281 118.917V123.375H153.392V118.917ZM160.823 134.852V138.237C160.823 139.058 160.158 139.723 159.336 139.723C158.515 139.723 157.85 139.058 157.85 138.237V134.852C156.966 134.336 156.364 133.388 156.364 132.292C156.364 130.653 157.697 129.32 159.336 129.32C160.976 129.32 162.309 130.653 162.309 132.292C162.309 133.388 161.707 134.336 160.823 134.852Z",
    fill: "url(#paint1_linear_1199_51228)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.145 102.373C314.023 60.0499 415.932 -9.61144 552.522 50.3595C693.569 112.287 664.443 265.627 581.303 263.635C513.279 262.005 481.827 171.901 550.677 127.336C619.528 82.7698 750.165 159.845 797.588 238.007",
    stroke: "#1C1B1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "12.32 12.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.97 75.1926L247.28 126.421L279.349 94.821L265.97 75.1926Z",
    fill: "#6BA9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.74 99.5233L295.633 118.479L247.264 126.413L282.74 99.5233Z",
    fill: "#6BA9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.331 94.7938L288.289 92.876L283.607 100.49L247.262 126.393L279.331 94.7938Z",
    fill: "#428AEB"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_1199_51228)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1199_51228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M864.801 249.995C864.801 247.508 866.816 245.493 869.303 245.493V245.493H871.554H874.93H884.081C885.739 245.493 887.083 246.837 887.083 248.495V248.495V248.495C887.083 250.049 888.343 251.309 889.897 251.309H904.596L912.978 251.306C916.332 251.304 919.051 254.023 919.051 257.376V257.376V273.804V281.188V281.188C918.927 286.073 914.929 290.055 910.043 290.055H873.81C868.834 290.055 864.801 286.022 864.801 281.046V249.995Z",
    fill: "#5886FF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 872.549,
    y: 248.4,
    width: 43.5938,
    height: 31.9688,
    rx: 3.37834,
    fill: "#BED0FF"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dddd_1199_51228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.61 217.888L954.266 208.521C953.276 207.986 952.039 208.356 951.504 209.346L938.679 233.093C938.144 234.083 938.514 235.32 939.504 235.855L956.848 245.222C957.839 245.757 959.075 245.387 959.61 244.397L972.435 220.65C972.97 219.66 972.601 218.423 971.61 217.888Z",
    fill: "#6DA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.454 220.648L954.248 213.517C953.84 213.296 953.331 213.448 953.111 213.856C952.89 214.264 953.043 214.774 953.451 214.994L966.656 222.126C967.064 222.346 967.573 222.194 967.793 221.786C968.014 221.378 967.862 220.869 967.454 220.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.055 223.233L952.85 216.102C952.442 215.882 951.933 216.034 951.712 216.442C951.492 216.85 951.644 217.359 952.052 217.579L965.257 224.711C965.665 224.931 966.175 224.779 966.395 224.371C966.615 223.963 966.463 223.454 966.055 223.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.664 225.819L951.459 218.688C951.051 218.467 950.542 218.619 950.322 219.027C950.101 219.435 950.254 219.945 950.662 220.165L963.867 227.297C964.275 227.517 964.784 227.365 965.004 226.957C965.225 226.549 965.072 226.039 964.664 225.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.561 224.244L950.061 221.274C949.653 221.053 949.144 221.205 948.923 221.613C948.703 222.021 948.855 222.531 949.263 222.751L954.763 225.721C955.171 225.942 955.681 225.79 955.901 225.382C956.121 224.974 955.969 224.464 955.561 224.244Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddd_1199_51228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.886 218.951C909.631 218.104 903.604 210.7 904.45 202.445C905.297 194.191 912.702 188.163 920.956 189.01C929.211 189.857 935.238 197.261 934.391 205.516C933.545 213.77 926.14 219.798 917.886 218.951Z",
    fill: "#FFB4CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.478 217.682C928.039 217.101 933.698 210.5 933.117 202.939C932.536 195.378 925.936 189.719 918.374 190.3C910.813 190.881 905.154 197.481 905.735 205.042C906.316 212.604 912.917 218.262 920.478 217.682Z",
    fill: "#FF5A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.074 199.544C922.49 198.417 920.281 194.584 920.283 194.566L918.859 208.455C918.89 208.141 917.652 207.823 916.829 207.738C914.837 207.534 913.163 208.468 913.024 209.818C912.886 211.167 914.415 212.43 916.406 212.633C918.398 212.838 920.053 211.902 920.192 210.552C920.213 210.349 920.052 210.135 920.071 209.946L921.169 199.245C921.169 199.245 922.272 200.627 924.117 201.479C925.618 202.173 926.183 204.251 926.183 204.251C926.183 204.251 926.521 201.286 924.074 199.544Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddd_1199_51228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.853 213.029L826.606 212.262C826.149 211.981 825.588 211.933 825.109 212.133L819.555 214.456C819.077 214.657 818.744 215.079 818.67 215.581L818.467 216.955C818.393 217.458 818.061 217.88 817.582 218.079L814.268 219.465C813.478 219.796 813.145 220.694 813.524 221.472L822.355 239.573C822.734 240.351 823.683 240.713 824.473 240.383L850.743 229.395C851.534 229.065 851.867 228.166 851.488 227.388L842.656 209.287C842.277 208.51 841.328 208.147 840.538 208.478L829.349 213.158C828.871 213.358 828.31 213.31 827.853 213.029Z",
    fill: "#FFA944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.906 209.148L819.839 219.214C818.836 219.634 818.287 220.812 818.614 221.845L823.886 238.513C824.212 239.546 825.291 240.043 826.294 239.623L850.361 229.557C851.365 229.137 851.913 227.959 851.587 226.927L846.315 210.258C845.988 209.226 844.909 208.728 843.906 209.148Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.906 209.148L819.839 219.214C818.836 219.634 818.287 220.812 818.614 221.845L823.886 238.513C824.212 239.546 825.291 240.043 826.294 239.623L850.361 229.557C851.365 229.137 851.913 227.959 851.587 226.927L846.315 210.258C845.988 209.226 844.909 208.728 843.906 209.148Z",
    fill: "#FFDEAC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dddd_1199_51228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885.538 184.421L861.33 186.389C859.068 186.572 857.383 188.555 857.567 190.818L858.873 206.883C859.057 209.145 861.04 210.83 863.302 210.646L887.51 208.679C889.772 208.495 891.457 206.512 891.273 204.25L889.967 188.184C889.783 185.922 887.8 184.237 885.538 184.421Z",
    fill: "#D1F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.144 185.954L861.064 187.992C859.933 188.084 859.09 189.076 859.182 190.207L860.559 207.145C860.651 208.276 861.642 209.119 862.773 209.027L887.854 206.988C888.985 206.896 889.827 205.905 889.735 204.774L888.359 187.835C888.267 186.704 887.276 185.862 886.144 185.954Z",
    fill: "#9AE0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.884 203.444C889.383 203.77 889.703 204.308 889.751 204.902V204.902C889.837 205.963 889.047 206.893 887.986 206.979L862.778 209.028C861.647 209.119 860.655 208.277 860.563 207.146L859.974 199.897C859.926 199.307 860.135 198.724 860.548 198.299L864.167 194.572C864.914 193.803 866.126 193.737 866.952 194.421L873.799 200.093C874.571 200.733 875.692 200.722 876.452 200.067L878.413 198.377C879.106 197.779 880.112 197.712 880.878 198.213L888.884 203.444Z",
    fill: "#4BDB62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.788 191.722C883.893 193.019 882.927 194.156 881.63 194.262C880.332 194.367 879.195 193.401 879.09 192.103C878.984 190.806 879.95 189.669 881.248 189.563C882.545 189.457 883.682 190.424 883.788 191.722Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.788 191.722C883.893 193.019 882.927 194.156 881.63 194.262C880.332 194.367 879.195 193.401 879.09 192.103C878.984 190.806 879.95 189.669 881.248 189.563C882.545 189.457 883.682 190.424 883.788 191.722Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_1199_51228",
    x: -191.239,
    y: 16.706,
    width: 702.683,
    height: 650.828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.47832
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92619
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.419608 0 0 0 0 0.819608 0 0 0 0.0496029 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.9132
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.4587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.419608 0 0 0 0 0.819608 0 0 0 0.0709935 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1199_51228",
    result: "effect2_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 38.5812
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.4146
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.419608 0 0 0 0 0.819608 0 0 0 0.0890065 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1199_51228",
    result: "effect3_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 79.47
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 52.3493
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.419608 0 0 0 0 0.819608 0 0 0 0.110397 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1199_51228",
    result: "effect4_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 217.716
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 143.416
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.419608 0 0 0 0 0.819608 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1199_51228",
    result: "effect5_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_1199_51228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_1199_51228",
    x: 783.926,
    y: 206.773,
    width: 216,
    height: 216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12854
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81152
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.243137 0 0 0 0 0.784314 0 0 0 0.0731663 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.88513
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.243137 0 0 0 0 0.784314 0 0 0 0.105 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1199_51228",
    result: "effect2_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.1691
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0588
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.243137 0 0 0 0 0.784314 0 0 0 0.136834 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1199_51228",
    result: "effect3_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 47
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.243137 0 0 0 0 0.784314 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1199_51228",
    result: "effect4_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1199_51228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddd_1199_51228",
    x: 858.434,
    y: 208.276,
    width: 194.246,
    height: 279.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.33666
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81152
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.427451 0 0 0 0 0.862745 0 0 0 0.0801346 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20.2849
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.427451 0 0 0 0 0.862745 0 0 0 0.115 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1199_51228",
    result: "effect2_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.8383
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0588
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.427451 0 0 0 0 0.862745 0 0 0 0.149865 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1199_51228",
    result: "effect3_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 162
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.427451 0 0 0 0 0.862745 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1199_51228",
    result: "effect4_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1199_51228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddd_1199_51228",
    x: 824.371,
    y: 136.931,
    width: 190.1,
    height: 190.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.86203
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.0784314 0 0 0 0 0.47451 0 0 0 0.205985 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.25417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.0784314 0 0 0 0 0.47451 0 0 0 0.304015 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1199_51228",
    result: "effect2_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 28
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.0784314 0 0 0 0 0.47451 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1199_51228",
    result: "effect3_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1199_51228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddd_1199_51228",
    x: 733.367,
    y: 161.355,
    width: 198.314,
    height: 192.15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.4945
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81152
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.388235 0 0 0 0 0.0588235 0 0 0 0.0975551 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.13211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.388235 0 0 0 0 0.0588235 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1199_51228",
    result: "effect2_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.94853
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0588
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.388235 0 0 0 0 0.0588235 0 0 0 0.182445 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1199_51228",
    result: "effect3_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.388235 0 0 0 0 0.0588235 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1199_51228",
    result: "effect4_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1199_51228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dddd_1199_51228",
    x: 777.402,
    y: 156.355,
    width: 194.035,
    height: 186.553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.3594
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81493
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.74902 0 0 0 0 0.101961 0 0 0 0.0871028 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.52345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.01804
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.74902 0 0 0 0 0.101961 0 0 0 0.125 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1199_51228",
    result: "effect2_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.706
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0815
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.74902 0 0 0 0 0.101961 0 0 0 0.162897 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1199_51228",
    result: "effect3_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.0978
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.0752
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.74902 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1199_51228",
    result: "effect4_dropShadow_1199_51228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1199_51228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1199_51228",
    x1: 135.223,
    y1: 45.0569,
    x2: 196.795,
    y2: 208.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4B0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1199_51228",
    x1: 159.336,
    y1: 110,
    x2: 159.336,
    y2: 145.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4359F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09DFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1199_51228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1068,
    height: 329,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1199_51228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.668,
    height: 35.668,
    fill: "white",
    transform: "translate(141.5 110)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1199_51228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M863.926 239.773H910.41C915.665 239.773 919.926 244.033 919.926 249.288V286.257C919.926 291.512 915.665 295.773 910.41 295.773H873.442C868.186 295.773 863.926 291.512 863.926 286.257V239.773Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTransferDoodle);
export default __webpack_public_path__ + "static/media/file_transfer_doodle.887b72710abe51fb67232958cd6c80b4.svg";
export { ForwardRef as ReactComponent };